// extracted by mini-css-extract-plugin
export default {"teamItem":"NewsListHome_teamItem__xGZZk","artistImg":"NewsListHome_artistImg__tDXGQ","newsDate":"NewsListHome_newsDate__wnUDs"};